import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingHeaderMediaProps {
  isSingleRow: boolean;
}

export const NewbuildingHeaderMedia: React.FC<React.PropsWithChildren<INewbuildingHeaderMediaProps>> = ({
  isSingleRow,
  children,
}) => {
  return <div className={classNames(styles['media'], isSingleRow && styles['single-row'])}>{children}</div>;
};
